import { toast } from "react-toastify";

const axios = require("axios");

function downloadFile(response) {
    let filename = 'export.csv'
    let headerLine = response.headers['Content-Disposition'];
    if(headerLine){
        let startFileNameIndex = headerLine.indexOf('"') + 1
        let endFileNameIndex = headerLine.lastIndexOf('"');
        filename = headerLine.substring(startFileNameIndex, endFileNameIndex);

    }

    var file = new Blob([response.data]);
    var elem = window.document.createElement("a");
    elem.href = window.URL.createObjectURL(file);
    elem.download = filename;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);

}

function handleSuccess(){
    toast.success("We have scheduled the export. You will receive an email with the exported file once the export job is complete.");

}
function handleFail() {
    toast.error("Something went wrong on server side. Please try again");

}

export const getToken = () => {
    if (localStorage.getItem("keptLogged") == "true") {
        return localStorage.getItem("token") || null;
    }
    return sessionStorage.getItem("token") || null;
};

async function basicApi(url){
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
        url,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
}



export const exportUsers = async () => {
    basicApi(`export/users`)
   .then((response) => {
       handleSuccess()
   })
   .catch((error) => {
    handleFail()
   })
};

export const exportPersons = async () => {
    basicApi(`export/persons`)
        .then((response) => {
            handleSuccess()
        })
        .catch((error) => {
            handleFail()
        })

};



export const exportDeals = async () => {
    basicApi(`export/deals`)
        .then((response) => {
            handleSuccess()
        })
        .catch((error) => {
            handleFail()
        })

    
};
export const exportTasks = async () => {
    basicApi(`export/tasks`)
        .then((response) => {
            handleSuccess()
        })
        .catch((error) => {
            handleFail()
        })

};
export const exportNotes = async () => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
        `export/notes`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    ).catch(e => { handleFail(); return; })
    handleSuccess()
    return response.data;
};

export const exportEvents = async (id) => {

    basicApi(`export/events/${id}`)
        .then((response) => {
            handleSuccess()
        })
        .catch((error) => {
            handleFail()
        })

};

export const exportAudience = async (id) => {
    basicApi(`export/audience/${id}`)
        .then((response) => {
            handleSuccess()
        })
        .catch((error) => {
            handleFail()
        })

};